export default {
  state: {
    deptId: '',
    vehicleName: '',
    keyword: ''
  },
  getters: {
    deptId: function deptId(state) {
      return state.deptId;
    },
    vehicleName: function vehicleName(state) {
      return state.deptId;
    },
    keyword: function keyword(state) {
      return state.keyword;
    }
  },
  mutations: {
    setDeptId: function setDeptId(state, deptId) {
      state.deptId = deptId;
    },
    setVehicleName: function setVehicleName(state, vehicleName) {
      state.vehicleName = vehicleName;
    },
    setKeyword: function setKeyword(state, keyword) {
      state.keyword = keyword;
    }
  }
};